import { createSlice } from "@reduxjs/toolkit";
import { getEnvConfig } from "../../config/config";
import {
  registerUser,
  toggleRegistrationLoader,
  updateRegistrationStatus,
  updateUserDetails,
} from "../webform/WebFormSlice";
import httpService from "../../support/http/HttpServices";

export const configurationInitialState = () => ({
  envConfig: getEnvConfig(),
  isMobile: false,
  authToken: "",
  orgID: "SPS",
  errorMessage: "",
  authTokenLoader: true,
  showError: false,
  resource: {},
  resourceLoader: false,
});
export const configurationSlice = createSlice({
  name: "config",
  initialState: configurationInitialState(),
  reducers: {
    updateEnvConfig: (state, action) => {
      state.envConfig = action.payload;
    },
    updateIsMobile: (state, action) => {
      state.isMobile = action.payload;
    },
    updateAuthToken: (state, action) => {
      state.authToken = action.payload;
    },
    updateOrgID: (state, action) => {
      state.orgID = action.payload;
    },
    updateErrorMessage: (state, action) => {
      state.errorMessage = action.payload;
    },
    updateAuthTokenLoader: (state, action) => {
      state.authTokenLoader = action.payload;
    },
    toggleShowError: (state, action) => {
      state.showError = action.payload;
    },
    updateResource: (state, action) => {
      state.resource = action.payload;
    },
    toggleResourceLoader: (state, action) => {
      state.resourceLoader = action.payload;
    },
  },
});
export const {
  updateEnvConfig,
  updateIsMobile,
  updateAuthToken,
  updateOrgID,
  updateAuthTokenLoader,
  updateErrorMessage,
  toggleShowError,
  updateResource,
  resourceLoader,
  toggleResourceLoader,
} = configurationSlice.actions;

export const getOAuthToken = () => async (dispatch, getState) => {
  dispatch(updateAuthTokenLoader(true));
  const envConfig = getState().config.envConfig;
  let data = {};
  return httpService
    .post(`${envConfig.hostname}${envConfig.api.oAuthToken}`, data, {})
    .then((response) => {
      if (response?.status === 200) {
        dispatch(updateAuthToken("Bearer " + response?.data?.access_token));
      } else {
        handleError();
      }
      dispatch(updateAuthTokenLoader(false));
    })
    .catch((error) => {
      dispatch(handleError());
    });
};

export const getHeaderFooter = () => async (dispatch, getState) => {
  const envConfig = getState().config.envConfig;
  dispatch(toggleResourceLoader(true));
  return httpService
    .customGet(`${envConfig.hostname}${envConfig.api.resourceLink}`, {}, {})
    .then((response) => {
      dispatch(updateResource(response?.data));
      dispatch(toggleResourceLoader(false));
    })
    .catch((error) => {
      dispatch(handleError());
    });
};

export const verifyToken = (resToken, data) => async (dispatch, getState) => {
  const envConfig = getState().config.envConfig;
  let request = { response: resToken };
  dispatch(toggleRegistrationLoader(true));
  dispatch(updateUserDetails(data));
  return httpService
    .post(`${envConfig.hostname}${envConfig.api.captchaVerify}`, request, {})
    .then((response) => {
      if (response?.status === 200 && response.data?.success) {
        dispatch(registerUser(data));
      } else {
        dispatch(updateRegistrationStatus("Error"));
        dispatch(toggleRegistrationLoader(false));
      }
    })
    .catch((error) => {
      dispatch(updateRegistrationStatus("Error"));
      dispatch(toggleRegistrationLoader(false));
    });
};

export const handleError = () => async (dispatch, getState) => {
  dispatch(updateErrorMessage("Something went wrong, Please try again later."));
  dispatch(toggleShowError(true));
};
export const envConfigSelector = (state) => state.config.envConfig;
export const isMobileSelector = (state) => state.config.isMobile;
export const authTokenSelector = (state) => state.config.authToken;
export const orgIDSelector = (state) => state.config.orgID;
export const authTokenLoaderSelector = (state) => state.config.authTokenLoader;
export const errorMessageSelector = (state) => state.config.errorMessage;
export const showErrorSelector = (state) => state.config.showError;
export const resourceSelector = (state) => state.config.resource;
export const resourceLoaderSelector = (state) => state.config.resourceLoader;

export default configurationSlice.reducer;
